import React, { createContext, useContext, useState, ReactNode } from 'react';

interface PanelState {
  isAssetsPanelOpen: boolean;
  isSettingsPanelOpen: boolean;
}

interface SharedPanelContextType extends PanelState {
  toggleAssetsPanel: (open: boolean) => void;
  toggleSettingsPanel: (open: boolean) => void;
}

const SharedPanelContext = createContext<SharedPanelContextType | undefined>(undefined);

interface SharedPanelProviderProps {
  children: ReactNode;
}

export const SharedPanelProvider: React.FC<SharedPanelProviderProps> = ({ children }) => {
  const [isAssetsPanelOpen, setIsAssetsPanelOpen] = useState(false);
  const [isSettingsPanelOpen, setIsSettingsPanelOpen] = useState(false);

  const toggleAssetsPanel = (open: boolean) => {
    setIsAssetsPanelOpen(open);
  };

  const toggleSettingsPanel = (open: boolean) => {
    setIsSettingsPanelOpen(open);
  };

  const contextValue: SharedPanelContextType = {
    isAssetsPanelOpen,
    isSettingsPanelOpen,
    toggleAssetsPanel,
    toggleSettingsPanel,
  };

  return (
    <SharedPanelContext.Provider value={contextValue}>
      {children}
    </SharedPanelContext.Provider>
  );
};

export const useSharedPanelState = () => {
  const context = useContext(SharedPanelContext);
  if (context === undefined) {
    console.error('useSharedPanelState must be used within a SharedPanelProvider');
    return {
      isAssetsPanelOpen: false,
      isSettingsPanelOpen: false,
      toggleAssetsPanel: () => {},
      toggleSettingsPanel: () => {},
    };
  }
  return context;
};